import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { handleApiError } from "../handleApiError";
import axiosInstance from "../axiosInstance";

const API_URL = "/category";

// GET ALL
export const getCategories = createAsyncThunk(
  "categories/getAll",
  async (params = {}, { rejectWithValue }) => {
    try {
      const query = new URLSearchParams();

      if (params.id) query.append("id", params.id);
      if (params.fields) query.append("fields", params.fields);
      if (params.sort) query.append("sort", params.sort);
      if (params.search) query.append("search", params.search);
      if (params.page) query.append("page", params.page);
      if (params.limit) query.append("limit", params.limit);

      const response = await axiosInstance.get(
        `${API_URL}?${query.toString()}`,
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// GET BY ID
export const getCategoryById = createAsyncThunk(
  "categories/getById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ADD
export const addCategory = createAsyncThunk(
  "categories/add",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(API_URL, data);

      toast.success("تمت إضافة الفئة بنجاح", { autoClose: 3000 });
      return response.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// UPDATE
export const updateCategory = createAsyncThunk(
  "categories/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`${API_URL}/${id}`, data);

      toast.success("تم تحديث الفئة بنجاح", { autoClose: 3000 });
      return { id, ...response.data };
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// DELETE
export const deleteCategory = createAsyncThunk(
  "categories/delete",
  async (id, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`${API_URL}/${id}`);

      toast.success("تم حذف الفئة بنجاح", { autoClose: 3000 });
      return { id };
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
